<!--模拟手机组件-->
<template>
  <div class="phone-wrapper">
    <div class="phone-header-wrapper">
      <div class="phone-header-circle"></div>
      <div class="phone-header-border"><span></span></div>
      <img src="../../assets/images/phone-01.png" class="image">
    </div>
    <div style="position: relative;">
      <img src="../../assets/images/phone.png" style="width: 100%;margin-top: -38px;width: 100%">
      <div style="text-align: center; color: #fff; font-size: xx-large;position: absolute; top: -50px;left: 0; background: rgba(0,0,0, .3);width: 100%;height: 100%; z-index: 2;overflow-x: hidden;">
        <p style="transform: translate(-48%, -131%);top: 50%; left: 50%; position: absolute; width: 100%;">敬请期待~</p>
      </div>
    </div>
    <!-- <div style="text-align: center;margin-top: 60%;font-size: xx-large;">敬请期待~</div> -->
    <!-- <div class="phone-logo">
      <img src="http://static.huaxuezoo.com/image/c25b39099f0b4702985dd1f87ccee1d" class="img">
      <div class="title">iSNOW+酒店 套票次卡产品(测试用无效)</div>
    </div> -->
    <!-- <div class="phone-info-wrapper">
      <div class="phone-title">iSNOW套票次卡产品</div>
      <div class="phone-info">
        <div class="flex phone-info-item">
          <div class="icon">ICON</div>
          <div>
            <div class="bigInfo">张家口市 崇礼县</div>
            <div class="smallInfo">iSNOW 滑雪场</div>
          </div>
        </div>
        <div class="flex phone-info-item">
          <div class="icon">ICON</div>
          <div>
            <div class="bigInfo">2018/06/13 17:31 - 2018/12/31 23:59</div>
            <div class="smallInfo">2018/12/31 23:59 报名截止</div>
          </div>
        </div>
        <div class="flex phone-info-item">
          <div class="icon">ICON</div>
          <div>
            <div class="bigInfo">退款信息</div>
            <div class="smallInfo">不可退款</div>
          </div>
        </div>
      </div>
    </div>
    <div class="phone-ticket-wrapper">
      <div class="flex bgWhite phone-ticket">
        <div>ICON</div>
        <div>
          <div class="bigInfo">iSNOW 5天雪票+酒店 套票</div>
          <div class="smallInfo">不限数量</div>
          <div class="smallInfo">购买成功后1分钟生效</div>
        </div>
        <div></div>
      </div>
      <div class="flex bgWhite phone-ticket">
        <div>ICON</div>
        <div>
          <div class="bigInfo">iSNOW 5天雪票+酒店 套票</div>
          <div class="smallInfo">不限数量</div>
          <div class="smallInfo">购买成功后1分钟生效</div>
        </div>
        <div></div>
      </div>
      <div class="flex bgWhite phone-ticket">
        <div>ICON</div>
        <div>
          <div class="bigInfo">iSNOW 5天雪票+酒店 套票</div>
          <div class="smallInfo">不限数量</div>
          <div class="smallInfo">购买成功后1分钟生效</div>
        </div>
        <div></div>
      </div>
    </div>
    <div class="phone-intro"></div>
    <div class="flex bgWhite phone-button-wrapper">
      <div>ICON</div>
      <div class="flex1 phone-button"><el-button size="mini" round>立即购买</el-button></div>
      <div>ICON</div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'w-phone',
  data () {
    return {
      radio: '1'
    }
  },
  methods: {},
  created () {}
}
</script>



// WEBPACK FOOTER //
// src/components/base/phone.vue